








import { computed, defineComponent } from "@vue/composition-api";
import { DateRangePickerValue, FormFields, FormValues } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";
import QueryFilter from "@/components/QueryFilter.vue";
import DateRangePicker from "@/components/DateRangePicker";
import { showList, preparedDate } from "../../config";

const PREPARED_DATES = "preparedDates";

export default defineComponent({
  name: "RangeSettings",
  components: { QueryFilter, DateRangePicker },
  props: {
    dateValue: { type: Object as () => DateRangePickerValue, required: true },
  },
  setup() {
    const setValue = (payload: DateRangePickerValue): FormValues => {
      return {
        timeFrom: payload.dateStart,
        timeTo: payload.dateEnd,
        preparedDates: preparedDate.CUSTOM,
      };
    };

    const fields = computed<FormFields>(() => [
      {
        name: PREPARED_DATES,
        title: $t("Show"),
        flexClass: "pl-5 pr-3 col-12 col-sm-6 col-md-6",
        list: showList,
        type: "select",
        clearable: false,
      },
      {
        name: "dateFromTo",
        flexClass: "pr-5 pl-3 col-12 col-sm-6 col-md-6",
        type: "dateRange",
        inputHandler: setValue,
      },
    ]);

    return {
      fields,
    };
  },
});
